<div class="chart-preview-box-wrap h-full">
  <div class="chart-preview-box-header pl-15 pt-3 mb-1 aligner-start">
    <ng-container *ngIf="activeHeaderColumn?.data_type as activeHeaderColumnType">
      <y42-column-type-icon [type]="activeHeaderColumnType"></y42-column-type-icon>
    </ng-container>
    <div class="ml-2">{{ activeHeaderColumn?.field_name }}</div>
    <div *ngIf="activeHeaderColumn?.description" class="ml-1 font-normal text-gray-600 fs-08">
      - {{ activeHeaderColumn?.description }}
    </div>
  </div>
  <div class="stats-wrapper">
    <div class="stats-viewer" [ngStyle]="{ 'min-width': state.activeHeaderColumnTypeIsNumber ? '375px' : 'auto' }">
      <div class="stats-title">
        <div class="variable-title">
          {{ activeHeaderColumn?.field_name }}
        </div>
        <div class="sample-size sample-size-transform">
          NULL =
          <span class="sample-size-number"
            >{{
              activeCardinality?.total?.['null_count_' + activeHeaderColumn?.field_name]
                ? (activeCardinality?.total?.['null_count_' + activeHeaderColumn?.field_name] || 0
                  | formatValueConversion)
                : 0
            }}
            ({{ state.total }}
            %)
          </span>
        </div>
        <div class="sample-size">
          N =
          <span class="sample-size-number">{{ activeCardinality?.total?.row_count || 0 | formatValueConversion }}</span>
        </div>
      </div>
      <div class="stats-row">
        <div class="stats-cell" *ngIf="state.activeHeaderColumnTypeIsNumber">
          <div class="stats-number">
            {{ activeCardinality?.total?.['avg_' + activeHeaderColumn?.field_name] || 0 | formatValueConversion: '':2 }}
          </div>
          Average
        </div>
        <div class="stats-cell" *ngIf="state.activeHeaderColumnTypeIsNumber">
          <div class="stats-number">
            {{ activeCardinality?.total?.['sum_' + activeHeaderColumn?.field_name] || 0 | formatValueConversion: '':2 }}
          </div>
          Sum
        </div>
        <div class="stats-cell" *ngIf="state.activeHeaderColumnTypeIsNumber">
          <div class="stats-number">
            {{ activeCardinality?.total?.['min_' + activeHeaderColumn?.field_name] || 0 | formatValueConversion: '':2 }}
          </div>
          Min
        </div>
        <div
          class="stats-cell"
          *ngIf="
            activeHeaderColumn?.data_type === ColumnTypeEnum.String ||
            activeHeaderColumn?.data_type === ColumnTypeEnum.ArrayString
          "
        >
          <div class="stats-number">
            {{ activeCardinality?.total?.['min_' + activeHeaderColumn?.field_name] || 0 }}
          </div>
          Min
        </div>
        <div
          class="stats-cell"
          *ngIf="
            activeHeaderColumn?.data_type === ColumnTypeEnum.Date ||
            activeHeaderColumn?.data_type === ColumnTypeEnum.Datetime ||
            activeHeaderColumn?.data_type === ColumnTypeEnum.Timestamp
          "
        >
          <div class="stats-number">
            {{ activeCardinality?.total?.['min_' + activeHeaderColumn?.field_name] || 0 }}
          </div>
          Min
        </div>
        <div class="stats-cell" *ngIf="state.activeHeaderColumnTypeIsNumber">
          <div class="stats-number">
            {{ activeCardinality?.total?.['max_' + activeHeaderColumn?.field_name] || 0 | formatValueConversion: '':2 }}
          </div>
          Max
        </div>
        <div
          class="stats-cell"
          *ngIf="
            activeHeaderColumn?.data_type === ColumnTypeEnum.Date ||
            activeHeaderColumn?.data_type === ColumnTypeEnum.Datetime ||
            activeHeaderColumn?.data_type === ColumnTypeEnum.Timestamp
          "
        >
          <div class="stats-number">
            {{ activeCardinality?.total?.['max_' + activeHeaderColumn?.field_name] || 0 }}
          </div>
          Max
        </div>
        <div
          class="stats-cell"
          *ngIf="
            activeHeaderColumn?.data_type === ColumnTypeEnum.String ||
            activeHeaderColumn?.data_type === ColumnTypeEnum.ArrayString
          "
        >
          <div class="stats-number">
            {{ activeCardinality?.total?.['max_' + activeHeaderColumn?.field_name] || 0 }}
          </div>
          Max
        </div>
        <div class="stats-cell" *ngIf="state.activeHeaderColumnTypeIsNumber">
          <div class="stats-number">
            {{ activeCardinality?.total?.['std_' + activeHeaderColumn?.field_name] || 0 | formatValueConversion: '':2 }}
          </div>
          Std. Dev.
        </div>
        <div class="stats-cell">
          <div class="stats-number">
            {{ activeCardinality?.distinct?.[activeHeaderColumn?.field_name || ''] || 0 | formatValueConversion: 'Automatic' }}
          </div>
          Distinct Values
        </div>
      </div>
      <div class="stats-row" *ngIf="state.activeHeaderColumnTypeIsNumber">
        <div class="stats-cell">
          <div class="stats-number">
            {{
              activeCardinality?.total?.['percentile_10_' + activeHeaderColumn?.field_name] || 0 | formatValueConversion: '':2
            }}
          </div>
          10th Percentile
        </div>
        <div class="stats-cell">
          <div class="stats-number">
            {{
              activeCardinality?.total?.['percentile_25_' + activeHeaderColumn?.field_name] || 0 | formatValueConversion: '':2
            }}
          </div>
          25th Perc.
        </div>
        <div class="stats-cell">
          <div class="stats-number">
            {{
              activeCardinality?.total?.['median_' + activeHeaderColumn?.field_name] || 0 | formatValueConversion: '':2
            }}
          </div>
          Median
        </div>
        <div class="stats-cell">
          <div class="stats-number">
            {{
              activeCardinality?.total?.['percentile_75_' + activeHeaderColumn?.field_name] || 0 | formatValueConversion: '':2
            }}
          </div>
          75th Perc.
        </div>
        <div class="stats-cell">
          <div class="stats-number">
            {{
              activeCardinality?.total?.['percentile_90_' + activeHeaderColumn?.field_name] || 0 | formatValueConversion: '':2
            }}
          </div>
          90th Perc.
        </div>
      </div>
    </div>
  </div>
</div>
<div class="pt-3 pl-2 pr-1 pb-2 border-left h-full chart-preview-box-header-wrap">
  <div class="chart-preview-box-header chart-preview-box-header-height aligner-start">
    Preview
    {{
      +(activeCardinality?.distinct?.[activeHeaderColumn?.field_name || ''] || 0) > 1000
        ? (1000 | formatValueConversion) + ' entries'
        : ''
    }}
    <mat-slide-toggle color="primary" [ngModel]="state.showDataZoom" (change)="showDataZoom$$.next($event.checked)">
      <span class="font-normal text-gray-700">Data Zoom</span>
    </mat-slide-toggle>
  </div>
  <div class="w-full echart-height" echarts [options]="state.echartOption" [autoResize]="true"></div>
</div>
